import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.Toolbar.Actions', {
    templateCardUpdateButtonTitle: 'Save the approval workflow as a draft',
    templateCardUpdateEnabledButton: 'Update the workflow',
    templateCardUpdateEnabledButtonTitle: 'Update the approval workflow',
    templateCardDiscardButton: 'Discard the changes',
    templateCardDiscardButtonTitle: 'Discard all changes made to the approval workflow',
    discardTemplateChangesPrompt: 'Are you sure?',
    templateCardDeleteButton: 'Delete',
    templateCardDeleteButtonTitle: 'Delete the approval workflow',
    removeTemplateConfirmPrompt: 'Are you sure?',
    startOverDialogButton: 'Restart',
    startOverDialogButtonTitle: 'Restart the selected requests',
    templateCardEnableButton: 'Activate the workflow',
    templateCardEnableButtonTitle: 'Activate the approval workflow',
    templateCardDisableButton: 'Deactivate',
    templateCardDisableButtonTitle: 'Deactivate the approval workflow',
    changeTemplateSettingsButtonTitle: 'Change the approval workflow settings',
    showContextHelp: 'Show the context help',
    copyTemplateButton: 'Copy workflow',
    copyTemplateButtonTitle: 'Copy workflow',
    copyTemplateUnsavedError: 'Please save your workflow first to be able to copy it.',
    exportPDF: 'Generate PDF',
    openVersionHistoryButtonTitle: 'Open version list of the workflow',
    fieldSettingsButtonTitle: 'Update field settings',
    versions: 'Versions',
    groupOfValues: 'Group of values',
});
